import { useRef } from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import HeaderImage from '@/components/HeaderImage';
import LeafIcon from '@/components/LeafIcon';
import { aideTitle, aideIntro, aideCategories, aideCustomText, aideTarifs } from '@/mocks/aideContent';

export default function AideQuotidienne() {
  const prestationsRef = useRef<HTMLDivElement>(null);
  const tarifsRef = useRef<HTMLDivElement>(null);

  const scrollTo = (ref: React.RefObject<HTMLDivElement | null>) => {
    ref.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <HeaderImage />

      <main className="max-w-3xl mx-auto px-6 md:px-10 py-12 md:py-16">
        <div className="flex flex-wrap gap-4 mb-10 justify-end">
          <button
            onClick={() => scrollTo(tarifsRef)}
            className="bg-primary-500 text-background-50 dark:text-foreground-950 px-6 py-3 rounded-full font-body text-sm tracking-wide hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Voir les tarifs
          </button>
        </div>

        <h1 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950 leading-snug mb-4">
          {aideTitle}
        </h1>
        <p className="font-body text-base md:text-lg text-foreground-800 leading-relaxed mb-10">
          {aideIntro}
        </p>

        <div ref={prestationsRef} />
        <LeafIcon />

        {aideCategories.map((cat, i) => (
          <div key={i} className="mb-10">
            <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950 leading-snug mb-4">
              {cat.title}
            </h2>
            <ul className="space-y-2">
              {cat.items.map((item, j) => (
                <li key={j} className="flex items-start gap-2 font-body text-base md:text-lg text-foreground-800">
                  <span className="text-foreground-950 text-2xl leading-none mt-0">·</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <p className="font-body text-base md:text-lg text-foreground-800 italic leading-relaxed mb-10">
          {aideCustomText}
        </p>

        <div ref={tarifsRef} />
        <LeafIcon />

        <div className="bg-background-100 rounded-lg p-6 md:p-8 mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950 leading-snug mb-8">
            {aideTarifs.title}
          </h2>
          <ul className="space-y-3 mb-6">
            {aideTarifs.items.map((item, i) => (
              <li key={i} className="flex items-start gap-2 font-body text-base md:text-lg text-foreground-800">
                <span className="text-foreground-950 text-2xl leading-none mt-0">·</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
          <p className="font-body text-base md:text-lg text-foreground-700 leading-relaxed">
            {aideTarifs.footer}
          </p>
        </div>
      </main>

      <Footer />
    </div>
  );
}